import logo from './logo.svg';
import './App.css';
import React, { Component } from 'react';
import { Button,ListItem, List, ListSubheader, ListItemText} from '@material-ui/core';
import { Line } from 'react-chartjs-2';
import X from './plots/X.json';
import H from './plots/H.json';
import T from './plots/T.json';
import CNOT from './plots/CNOT.json';
import QCBM from './plots/QCBM.json';
import QFT from './plots/QFT.json';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

class App extends Component{


	constructor(props){
		super(props);
		let data;
		this.data = {
			"X": X,
			"H": H,
			"T": T,
			"CNOT": CNOT,
			"QCBM": QCBM,
			"QFT": QFT
		}
		this.state  = this.data.X;
	}

	handleClick(evt){
		this.setState(this.data[evt]);
	}

	render() {
  	return (
							<Grid container> 
								<Grid item xs={3}> 
									<List 
										component="nav"
										aria-labelledby="nested-list-subheader">
										<ListItem button onClick={() => this.handleClick("X")} >
											<ListItemText primary="X"/>
										</ListItem>
										<ListItem button onClick={() => this.handleClick("H")}>
											<ListItemText primary="H"/>
										</ListItem>
										<ListItem button onClick={() => this.handleClick("T")} >
											<ListItemText primary="T"/>
										</ListItem>
										<ListItem button onClick={() => this.handleClick("CNOT")} >
											<ListItemText primary="CNOT"/>
										</ListItem>
										<ListItem button onClick={() => this.handleClick("QCBM")} >
											<ListItemText primary="QCBM"/>
										</ListItem>
										<ListItem button onClick={() => this.handleClick("QFT")}>
											<ListItemText primary="QFT"/>
										</ListItem>
										
									</List>
								</Grid>
								<Grid item xs={9}>
									<Line data={this.state.data} options={{
										scales:{
										yAxes: [
											{
												display: true,
												labelString: "ns",
												type: "logarithmic",
												position: "left",
											}],
										xAxes: [
											{
															labelString: "nqubits"
											}

										],
									}
									}
									}/>
								</Grid>
							</Grid>
  	);
	}
}

export default App;
